import UI from "../../components/ExcerciseTypes/Design/UserInterface";
import T6 from "../../components/ExcerciseTypes/TypeIn/T6";
import D1 from "../../components/ExcerciseTypes/Design/TypeIn";

const json = {
  1: { // Exercise num
    unit: "Unit 12",
    id: "SB3-U12-P85-E1",
    audio: "img/FriendsPlus/Page85/Audio/audio-e1-p85.mp3",
    video: "",
    component: T6,
    stylesTextInput: { borderBottomWidth: 0, backgroundColor: 'transparent' },
    exerciseKey: "img/FriendsPlus/Page85/E1/Key/answerKey.png",
    inputSize: 34,
    maxLength: 1,
    padding: 0,
    textAlign: 'center',
    titleImage: "",
    titleQuestion: [
      {
        color: "#44509f", num: "1",
        title: 'Listen and write T (true) or F (false). <headphone name="136" src="img/FriendsPlus/Page85/Audio/tieude-e1-p85.mp3"></headphone>',
      },
    ],
    questionImage: [],
    questions: [
      {
        title: `
          <div style='display: flex; flex-direction: row;position: relative;'>
            <img src="img/FriendsPlus/Page85/E1/1.jpg" style="width: 120%">
            <div style=" position: absolute; top: 155px; left: 344px; "><input id='0' /></div>
            <div style=" position: absolute; top: 155px; left: 532px; "><input id='1' /></div>
            <div style=" position: absolute; top: 155px; left: 722px; "><input id='2' /></div>
            <div style=" position: absolute; top: 155px; left: 911px; "><input id='3' /></div>
          </div>
        `,
        answer: ['F', 'F', 'T', 'T'],
      },
    ],
  },
  2: { // Exercise num
    unit: 'Unit 12',
    id: 'SB3-U12-P85-E2',
    audio: '',
    video: '',
    component: UI,
    recorder: true,
    question: [],
    questionImage: [[{ url: 'img/FriendsPlus/Page85/E2/1.jpg' }]],
  },
  3: { // Exercise num
    unit: 'Unit 12',
    id: 'SB3-U12-P85-E3',
    audio: '',
    video: '',
    component: UI,
    question: [],
    questionImage: [
      [{ url: 'img/FriendsPlus/Page85/E3/1.jpg' }],
      [{ url: 'img/FriendsPlus/Page85/E3/2.jpg' }],
    ],
  },
  4: { // Exercise num
    unit: 'Unit 12',
    id: 'SB3-U12-P85-E4',
    audio: '',
    video: '',
    component: D1,
    exerciseKey: '',
    isAllowSubmit: false,
    hideBtnFooter: true,
    question: [],
    questionImage: [
      [
        // Column1
        { url: 'img/FriendsPlus/Page85/E4/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page85/E4/2.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page85/E4/3.jpg' },
        { url: 'img/FriendsPlus/Page85/E4/4.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page85/E4/5.jpg' },
        { url: 'img/FriendsPlus/Page85/E4/6.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page85/E4/7.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page85/E4/8.jpg' },
        { url: 'img/FriendsPlus/Page85/E4/9.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page85/E4/10.jpg' },
        { url: 'img/FriendsPlus/Page85/E4/11.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page85/E4/12.jpg' },
      ],
      [{ url: 'img/FriendsPlus/Page85/E4/13.jpg' }],
    ]
  },
}

export default json;